export default "__VITE_ASSET__8d265e8c__"